const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the vimeo player component
 * @argument {$sce} $sce the resource defined to manage $sce
 */

app.directive('vimeoPlayer', ['Analyze', '$q', function (Analyze, $q) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      source: '=',
      mediaId: '=',
      tracking: '=?',
      onComplete: '&?',
      completionPercent: '=?'
    },
    template: require('../../templates/directives/vimeo-player.html'),
    link: function (scope, element, attrs) {
      var self = this;
      
      var loadApi = function () {
        var searchScript = window.Vimeo ? true : false;
        if (searchScript) {
          playerInfo.available = true;
          playerInfo.onReady();
          return;
        }

        var tag = document.createElement('script');
        tag.id = 'vmplayersource';
        tag.src = 'https://player.vimeo.com/api/player.js';

        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        var attempts = 0;
        var checkCompletion = function() {
          setTimeout(function() {
            attempts++;
            if (window.Vimeo) {
              playerInfo.available = true;
              playerInfo.onReady();
              return;
            }
            if (attempts > 99) {
              return;
            }
            checkCompletion();
          }, 50);
        };
        checkCompletion();
      };

      var playerInfo = {
        player: null,
        onReady: function() {
          var iframe = document.getElementById('vmplayer');
          iframe.src = 'https://player.vimeo.com/video/' + scope.source;

          playerInfo.player = new Vimeo.Player(iframe);
          window.player = playerInfo.player;
          playerInfo.player.on('pause', function() {
            playerInfo.recordPosition();
          });

          playerInfo.player.on('ended', function() {
            playerInfo.recordPosition()
            .then(function() {
              return playerInfo.changePosition(0);
            }).then(function() {
              playerInfo.player.pause();              
            });
          });

          playerInfo.initialized = true;

          if (playerInfo.seekTo) {
            playerInfo.changePosition(playerInfo.seekTo);
          }
        },
        seekTo: null,
        changePosition: function(percent) {
          return playerInfo.player.getDuration().then(function(duration) {
            playerInfo.player.setCurrentTime(duration * (percent / 100));
            playerInfo.seekTo = null;
          });
        },
        recordPosition: function() {
          if (!scope.mediaId) {
            return;
          }

          return $q.all([playerInfo.player.getCurrentTime(), playerInfo.player.getDuration()])
          .then(function(results) {
            var position = results[0] / results[1] * 100;
            Analyze.record({resource: 'user-videos'}, {content: scope.mediaId, position: position}).$promise.then(function(item) {console.log('recorded item: ', item)});
            scope.tracking.checkFurthest(position);

            if (scope.completionPercent && scope.onComplete && typeof scope.completionPercent === 'number' && position > scope.completionPercent) {
              scope.onComplete();
            }
          });
        }
      };

      scope.$on('$destroy', function() {
        playerInfo.recordPosition();
      });

      self.initialize = function() {
        playerInfo.initialized = false;
        var ratio = (attrs.height / attrs.width) * 100;
        element[0].style.paddingTop = ratio + '%';
        loadApi();
        if (scope.mediaId) {
          Analyze.userVideos({subresource: scope.mediaId}).$promise
          .then(function(item) {
            if (typeof scope.completionPercent === 'number' && typeof item.furthest_position === 'number' && item.furthest_position > scope.completionPercent) {
              scope.onComplete();
            }
            if (!item || !item.last_position) {
              scope.tracking.setInitialPosition(0);
              return;
            }
            scope.tracking.setInitialPosition(item.last_position);
            if (!playerInfo.initialized) {
              playerInfo.seekTo = item.last_position;
              return;
            }
            playerInfo.changePosition(item.last_position);
          });
        }
      };

      if (scope.source) {
        self.initialize();
      }
    }
  };

}]);